<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="Report damage" /></div>
    </div>
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div v-if="!properties.loadingStatus.isLoading" class="columns">
      <div class="column is-6">
        <form novalidate test-id="form" @submit.prevent="reportDamage">
          <LsSelect
            v-model="property_id"
            :validation="{ required: true }"
            class="options-spacing"
            placeholder="Select your property"
            track-id="property_damage_view-property_id"
            test-id="property_id"
            label="Which property was affected?"
            name="property_id"
            :options="streetOptionsArray"
          />
          <LsDatepicker
            v-model="damage_occurred_at"
            :validation="{ required: true }"
            class="options-spacing"
            track-id="property_damage_view-damage_occurred_at"
            test-id="damage_occurred_at"
            label="When did you first notice this?"
            name="damage_occurred_at"
            :min-date="minDate"
            :max-date="maxDate"
          />
          <LsInput
            v-model="damage_details"
            :validation="{ required: true }"
            type="textarea"
            class="options-spacing"
            label="Please describe the damage in detail"
            track-id="property_damage_view-damage_details"
            placeholder="e.g. Flowers trampled underfoot"
            name="damage_details"
          />
          <LsUploadPhotos
            v-model="pendingImages"
            :validation="{ required: true }"
            class="options-spacing"
            track-id="property_damage_view-pending_images"
            test-id="pendingImages"
            label="Upload photos"
            name="pendingImages"
          />
          <LsInputMasked
            v-model="damage_cost"
            :validation="{ required: true }"
            label="What is the value of the damaged items?"
            test-id="damage_cost"
            track-id="property_damage_view-damage_cost"
            name="damage_cost"
            mask="currency"
          />
          <LsRadioButtons
            v-model="resolution_desired"
            class="options-spacing"
            :validation="{ required: true }"
            track-id="property_damage_view-resolution_desired"
            label="Upon resolution, which would you prefer?"
            :options="[
              { label: 'Replace', value: 'replacement' },
              { label: 'Reimburse', value: 'reimbursement' },
            ]"
            name="resolution_desired"
          />
          <LsRadioButtons
            v-model="third_parties"
            :validation="{ required: true }"
            class="options-spacing"
            track-id="property_damage_view-radio_third_parties"
            label="Have any other contractors or third parties visited your property recently"
            :options="[{ label: 'No', value: false }, { label: 'Yes', value: true }]"
            name="third_parties"
          />
          <LsButton
            class="submit-button"
            test-id="submit_report"
            text="SUBMIT REPORT"
            bg-color="tertiary"
            track-id="property_damage_view-submit_report"
            type="submit"
            :loading="support.loadingStatus.isUpdating"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LsButton,
  LsInput,
  LsSelect,
  LsUploadPhotos,
  LsRadioButtons,
  LsDatepicker,
  LsInputMasked,
} from '@/components/common';
import _ from 'lodash';
import { mapActions, mapState, mapGetters } from 'vuex';
import { lsValidationService } from 'ls-vue-common';
import {
  SUPPORT__REPORT_DAMAGE,
  PROPERTIES__PROPERTIES_IN_ARRAY,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
} from '@/store/types';
import moment from 'moment';
import { LsSupportHeader } from '../components';
import { lsUploadPhotosHelper } from '@/helpers';

export default {
  name: 'PropertyDamageView',
  components: {
    LsButton,
    LsSelect,
    LsInput,
    LsUploadPhotos,
    LsRadioButtons,
    LsDatepicker,
    LsInputMasked,
    LsSupportHeader,
  },
  data() {
    return {
      property_id: null,
      damage_occurred_at: moment().toDate(),
      damage_details: '',
      damage_cost: '',
      resolution_desired: '',
      third_parties: '',
      pendingImages: [],
      minDate: moment()
        .subtract(3, 'months')
        .toDate(),
      maxDate: moment().toDate(),
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapState(['support', 'properties']),
    ...mapGetters([PROPERTIES__PROPERTIES_IN_ARRAY]),
    streetOptionsArray() {
      return _.map(this[PROPERTIES__PROPERTIES_IN_ARRAY], (property) => {
        return {
          label: property.street,
          value: property.property_id,
        };
      });
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
    this.property_id = this.streetOptionsArray[0].value;
  },
  methods: {
    ...mapActions([SUPPORT__REPORT_DAMAGE, PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    async reportDamage() {
      const isFormValid = await this.$validator.validateAll();
      const isUploadValid = lsUploadPhotosHelper.isValidUpload(this.pendingImages);

      if (!isFormValid || !isUploadValid) {
        return lsValidationService.scrollToInvalid();
      }

      this[SUPPORT__REPORT_DAMAGE]({
        property_id: this.property_id,
        damage_occurred_at: this.damage_occurred_at,
        damage_details: this.damage_details,
        damage_cost: this.damage_cost,
        resolution_desired: this.resolution_desired,
        third_parties: this.third_parties,
        pendingImages: this.pendingImages,
        onSuccess: () => {
          this.$router.push({ name: 'support' });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.options-spacing {
  padding: 10px 0px;
  @media (max-width: $mobile-max-width) {
    padding: 5px 0px;
  }
}
.submit-button {
  margin: 20px 0;
}
</style>
